<template>
  <div class="home">
    <myHeader />
    <myContainer />
    <myFooter />
  </div>
</template>

<script>

import myHeader from '@/components/myHeader'
import myContainer from '@/components/myContainer'
import myFooter from '@/components/myFooter'
export default {
  name: 'Home',
  components: { myHeader, myContainer, myFooter },
  data(){
    return {

    }
  },
}
</script>
<style lang="less" scoped>
.home{
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: white;
}
</style>